module.exports = __webpack_public_path__ + "static/media/CancelIllustration.03725560.jpg";